require('./ctxTagsDropdown.style.scss');

class ctxTagsDropdownController {
    constructor($scope, $element, $filter) {
        this.$scope = $scope;
        this.$element = $element;
        this.$filter = $filter;
        this.filters = [];
        this.selectedTags = [];
        this.filterFlag = 0;

        this.$scope.$watchCollection(() => this.itemOptions, () => {
            if (!this.itemOptions || !this.itemOptions.length) return;
            this.itemOptions.forEach(opt => {
                if (!opt) return;
                if (opt.filter && !opt.filter.color) opt.filter.color = 'default-class';
                this.filters.push(opt.filter);
                if (opt.children && opt.children.length) {
                    opt.children.forEach(child => {
                        this.filters.push(child.filter)
                    })
                }
            });
            this.filterApply();
        });

        this.$scope.$watchCollection(() => this.selectedTags, () => {
            this.enabledOptions = this.selectedTags.map(item => item.name);
        });

    }

    checkAll() {
        let selectAll = this.checkAllModel;
        this.filters.forEach(filter => {
            if (!filter.defaultValue) {
                if (selectAll === 0) filter.reset();
                filter.options.forEach(option => { filter.optionsModel[option.value] = selectAll === 0 ? undefined : true; })
            }
        });
    }

    refresh() {
        this.checkAllModel = 0;
        if (this.onFilterChanged) this.onFilterChanged();
    }

    filterApply() {
        this.showPopup = false;
        this.filters.forEach((filter) => {
            const valuesArray = [], displayArray = [];
            Object.keys(filter.optionsModel).forEach((key) => {
                if (filter.optionsModel[key]) {
                    valuesArray.push(key);
                    displayArray.push(filter.options.filter(option => option.value === key)[0].label);
                }
            });
            filter.filterBy = valuesArray.join('||');
            filter.displayFilterBy = displayArray;
        });
        this.filterFlag++;
        if (this.onFilterChanged) this.onFilterChanged();
    }

    openDropDown() {
        this.showPopup = !this.showPopup;
    }
}

ctxTagsDropdownController.$inject = ['$scope', '$element', '$filter'];

const ctxTagsDropdownComponent = {
    controller: ctxTagsDropdownController,
    template: require('./ctxTagsDropdown.template.html'),
    scope: {},
    bindings: {
        label: '@?',
        itemOptions: '=',
        enabledOptions: '=',
        onFilterChanged: '&?'
    }
};

module.exports = ctxTagsDropdownComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxTagsDropdown/ctxTagsDropdown.component.js